export default __webpack_public_path__ + "assets/ae7899.gif";